import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    void this.router.navigate([this.authService.defaultRoute()]);
    return false;
  }
}
